/**
 * @class DetailsModal
 * @extends HTMLElement
 */
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLDetailsElement} */
    this.detailsContainer = /** @type {HTMLDetailsElement} */ (this.querySelector('details'));
    /** @type {HTMLElement} */
    this.summaryToggle = /** @type {HTMLElement} */ (this.querySelector('summary'));
    /** @type {((event: MouseEvent) => void) | null} */
    this.onBodyClickEvent = null;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    /** @type {HTMLButtonElement} */
    const closeButton = /** @type {HTMLButtonElement} */ (this.querySelector('button[type="button"]'));
    closeButton.addEventListener('click', () => this.close());

    this.summaryToggle.setAttribute('role', 'button');
  }

  /**
   * @returns {boolean}
   */
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  /**
   * @param {MouseEvent} event
   */
  onSummaryClick(event) {
    event.preventDefault();
    /** @type {HTMLDetailsElement | null} */
    const details = /** @type {Element} */ (event.target).closest('details');
    if (details) {
      details.hasAttribute('open') ? this.close() : this.open(event);
    }
  }

  /**
   * @param {MouseEvent} event
   */
  onBodyClick(event) {
    const target = /** @type {Element} */ (event.target);
    if (!this.contains(target) || target.classList.contains('modal-overlay')) {this.close(false);}
  }

  /**
   * @param {MouseEvent} event
   */
  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    /** @type {HTMLDetailsElement | null} */
    const details = /** @type {Element} */ (event.target).closest('details');
    if (details) {
      details.setAttribute('open', 'true');
    }
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const trapContainer = /** @type {HTMLElement | null} */ (this.detailsContainer.querySelector('[tabindex="-1"]'));
    const trapInput = /** @type {HTMLElement | null} */ (this.detailsContainer.querySelector('input:not([type="hidden"])'));
    if (trapContainer) {
      trapFocus(trapContainer, trapInput);
    }
  }

  /**
   * @param {boolean} [focusToggle=true]
   */
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
